import { render, staticRenderFns } from "./Campaign2023.vue?vue&type=template&id=dee77c42"
import script from "./Campaign2023.vue?vue&type=script&lang=js"
export * from "./Campaign2023.vue?vue&type=script&lang=js"
import style0 from "./Campaign2023.vue?vue&type=style&index=0&id=dee77c42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports